/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ section: NonNullable<unknown>, venue: NonNullable<unknown>, tab: NonNullable<unknown> }} Tournament_Wiz_Tip_Rooms_BInputs */



/**
* | output |
* | --- |
* | "{section} is at the bottom of the {venue} section, on the {tab} tab. Tables fill the rooms in order, and each table shows its room." |
*
* @param {Tournament_Wiz_Tip_Rooms_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_rooms_b = /** @type {((inputs: Tournament_Wiz_Tip_Rooms_BInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Rooms_BInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.section} se trouve en bas de la section ${i?.venue}, dans l'onglet ${i?.tab}. Les tables remplissent les salles dans l'ordre, et chaque table affiche sa salle.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.section} está al final de la sección ${i?.venue}, en la pestaña ${i?.tab}. Las mesas llenan las salas en orden, y cada mesa muestra su sala.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.section} fica no fim da seção ${i?.venue}, na aba ${i?.tab}. As mesas preenchem as salas em ordem, e cada mesa mostra sua sala.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.section} è in fondo alla sezione ${i?.venue}, nella scheda ${i?.tab}. I tavoli riempiono le sale in ordine, e ogni tavolo mostra la sua sala.`)
	return /** @type {LocalizedString} */ (`${i?.section} is at the bottom of the ${i?.venue} section, on the ${i?.tab} tab. Tables fill the rooms in order, and each table shows its room.`)
});